<template>
  <el-container v-bind:id="resetData.id" v-if="isShow">
    <el-header>

      <div @mousedown="mousedown">
        <span class="header_line"></span>
        <span class="title" v-html="resetData.title"></span>
      </div>

    </el-header>

    <el-main>

      <!-- 手机 -->
      <el-form v-if="resetData.id=='resetTelephone'" :model="telephoneForm" ref="ruleForm" label-width="auto"
        class="demo-ruleForm">
        <el-form-item prop="telephone">
          <el-input v-model="telephoneForm.telephone" clearable placeholder="请输入手机号">
            <i slot="prefix" class="el-input__icon el-icon-phone-outline">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="message">
          <el-input :maxlength='6' v-model="telephoneForm.code" placeholder="请输入短信验证码">
            <i slot="prefix" class="el-input__icon el-icon-message">
            </i>
          </el-input>
          <el-link :underline="false" type="success" v-if="telephoneForm.codeState == 1" @click="getSMSCode(1)">发送验证码
          </el-link>
          <el-link :underline="false" type="success" v-if="telephoneForm.codeState == 2" @click="getSMSCode(2)">
            {{telephoneForm.second}}s后重新发送
          </el-link>
        </el-form-item>
      </el-form>

      <!-- 邮箱 -->
      <el-form v-if="resetData.id=='restEmail'" :model="emailForm" ref="ruleForm" label-width="auto"
        class="demo-ruleForm">
        <el-form-item prop="telephone">
          <el-input v-model="emailForm.email" clearable placeholder="请输入邮箱">
            <i slot="prefix" class="el-input__icon el-icon-link">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="message">
          <el-input :maxlength='6' v-model="emailForm.code" placeholder="请输入邮箱验证码">
            <i slot="prefix" class="el-input__icon el-icon-message">
            </i>
          </el-input>
          <el-link :underline="false" type="success" v-if="emailForm.codeState == 1" @click="getEmailCode(1)">发送验证码
          </el-link>
          <el-link :underline="false" type="success" v-if="emailForm.codeState == 2" @click="getEmailCode(2)">
            {{emailForm.second}}s后重新发送
          </el-link>
        </el-form-item>
      </el-form>

    </el-main>

    <el-footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="resetBtn">确 定</el-button>
        <el-button class="close" @click="closeDialog">取 消</el-button>
      </span>
    </el-footer>

  </el-container>
</template>
 
<script>
import utils from "@/util/index";
import {
  emailCode,
  resetEmail,
  sendSms,
  resetTelephone
} from "@/network/loginRequest/api";

export default {
  name: "Window",
  props: {
    resetData: {
      type: Object
    },
    userId: {
      type: String
    }
  },
  data() {
    return {
      selectElement: "",
      isShow: true,

      // 电话
      telephoneForm: {
        telephone: "",
        code: "",
        second: 60,
        codeState: 1 // 1--未发送，2--已发送
      },

      // 邮箱
      emailForm: {
        email: "",
        code: "",
        second: 60,
        codeState: 1 // 1--未发送，2--已发送
      }
    };
  },

  created() {
    this.isShow = this.resetData.isShow;
  },

  watch: {
    resetData() {
      this.isShow = this.resetData.isShow;
    }
  },

  methods: {
    //确定按钮
    resetBtn() {
      //修改邮箱
      if (this.resetData.id == "restEmail") {
        //验证邮箱
        let RegPhone = new RegExp(
          /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        );

        var email = this.emailForm.email;
        var code = this.emailForm.code;
        var fd = new FormData();
        fd.append("email", email);
        fd.append("vCode", code);
        fd.append("id", this.userId);

        if (email == "") {
          utils.tips("warning", "请输入邮箱");
          return false;
        }

        if (!RegPhone.test(email)) {
          utils.tips("warning", "请输入正确的邮箱");
          return false;
        }

        if (code == "") {
          utils.tips("warning", "请输入邮箱验证码");
          return false;
        }

        resetEmail(fd).then(res => {
          if (res.data.success) {
            this.$emit("resetEmailData", this.emailForm.email);
            this.emailForm.email = "";
            this.emailForm.code = "";
            this.isShow = false;
            utils.tips("warning", res.data.code);
          } else {
            utils.tips("warning", res.data.code);
          }
        });
      }

      //修改手机号
      if (this.resetData.id == "resetTelephone") {
        //验证手机号
        let RegPhone = new RegExp(
          /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
        ); //验证手机号
        var tel = this.telephoneForm.telephone;
        var code = this.telephoneForm.code;
        let fd = new FormData();
        fd.append("telephone", tel);
        fd.append("vCode", code);
        fd.append("id", this.userId);

        if (tel == "") {
          utils.tips("warning", "请输入手机号码");
          return false;
        }
        if (!RegPhone.test(tel)) {
          utils.tips("warning", "请输入正确的手机号码");
          return false;
        }

        if (code == "") {
          utils.tips("warning", "请输入手机验证码");
          return false;
        }

        resetTelephone(fd).then(res => {
          if (res.data.success) {
            this.$emit("resetPhoneData", this.telephoneForm.telephone);
            this.telephoneForm.telephone = "";
            this.telephoneForm.code = "";
            this.isShow = false;
            utils.tips("warning", res.data.code);
          } else {
            utils.tips("warning", res.data.code);
          }
        });
      }
    },

    //取消按钮
    closeDialog(e) {
      if (this.resetData.id == "restEmail") {
        this.emailForm.email = "";
        this.emailForm.code = "";
      }

      if (this.resetData.id == "resetTelephone") {
        this.telephoneForm.telephone = "";
        this.telephoneForm.code = "";
      }

      this.isShow = false;
    },

    //手机验证
    getSMSCode(type) {
      let RegPhone = new RegExp(
        /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      ); //验证手机号
      var tel = this.telephoneForm.telephone;
      if (tel == "") {
        utils.tips("warning", "请输入手机号码");
        return false;
      }
      if (!RegPhone.test(tel)) {
        utils.tips("warning", "请输入正确的手机号码");
        return false;
      }

      if (type == 1) {
        sendSms(tel)
          .then(res => {
            if (res.data.state == "1") {
              utils.tips("success", "发送成功！");
              this.telephoneForm.codeState = 2;
              let that = this;
              let t = setInterval(() => {
                if (this.telephoneForm.second == 0) {
                  that.telephoneForm.second = 60;
                  clearInterval(t);
                  this.telephoneForm.codeState = 1;
                } else {
                  that.telephoneForm.second = that.telephoneForm.second - 1;
                }
              }, 1000);
            } else {
              utils.tips("info", res.data.code);
            }
          })
          .catch(err => {
            utils.tips("error", err);
          });
      }
    },

    //邮箱验证
    getEmailCode(type) {
      //验证邮箱
      let RegPhone = new RegExp(
        /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      );

      var email = this.emailForm.email;
      var fd = new FormData();
      fd.append("email", email);

      if (email == "") {
        utils.tips("warning", "请输入邮箱");
        return false;
      }

      if (!RegPhone.test(email)) {
        utils.tips("warning", "请输入正确的邮箱");
        return false;
      }

      if (type == 1) {
        emailCode(fd)
          .then(res => {
            if (res.data.state == "1") {
              utils.tips("success", "发送成功！");
              this.emailForm.codeState = 2;
              let that = this;
              let t = setInterval(() => {
                if (this.emailForm.second == 0) {
                  that.emailForm.second = 60;
                  clearInterval(t);
                  this.emailForm.codeState = 1;
                } else {
                  that.emailForm.second = that.emailForm.second - 1;
                }
              }, 1000);
            } else {
              utils.tips("info", res.data.code);
            }
          })
          .catch(err => {
            utils.tips("error", err);
          });
      }
    },

    //窗口移动过
    mousedown(event) {
      this.selectElement = document.getElementById(this.resetData.id);
      var div1 = this.selectElement;
      this.selectElement.style.cursor = "move";

      var distanceX = event.clientX - this.selectElement.offsetLeft;
      var distanceY = event.clientY - this.selectElement.offsetTop;

      document.onmousemove = function(ev) {
        var oevent = ev || event;
        div1.style.left = oevent.clientX - distanceX + "px";
        div1.style.top = oevent.clientY - distanceY + "px";
      };

      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
        div1.style.cursor = "default";
      };
    }
  }
};
</script>
 
<style lang='less' scoped>
.el-container {
  position: absolute;
  height: 239px;
  width: 384px;
  top: 20%;
  left: 35%;
  border-radius: 10px;
  box-shadow: 0 0 10px #ccc;
  overflow: hidden;
  top: 32%;
  left: 45%;
}

.dialog-footer {
  text-align: right;
  display: flex;
  justify-content: space-evenly;

  /deep/.el-button--primary {
    background-color: #24ba58;
    border-color: #24ba58;
  }

  /deep/.el-button:focus,
  .close:hover {
    color: #333;
    border-color: #24ba58;
    background-color: #e9f5ed;
  }

  /deep/.is-disabled {
    background-color: #ccc;
    border-color: #ccc;
    color: #333;
  }

  /deep/.is-disabled:hover {
    background-color: #ccc;
    border-color: #ccc;
    color: #333;
  }
}

.el-main {
  padding: 0 20px;
  background-color: white;
}

.el-footer {
  background-color: white;
}

.el-header {
  background-color: white;
  color: rgba(36, 186, 88, 1);
  line-height: 60px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  div {
    display: flex;
    align-items: center;
  }

  .header_line {
    display: block;
    width: 4px;
    height: 18px;
    background: rgba(36, 186, 88, 1);
    border-radius: 2px;
    margin-right: 8px;
  }
}

.el-aside {
  color: #333;
}

// 表单样式
.el-main {
  .el-form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-form-item {
      width: 100%;
      margin-bottom: 10px;

      .el-form-item__content {
        position: relative;

        .el-link {
          position: absolute;
          top: 0;
          right: 5px;
        }
      }

      .btn_submit {
        width: 100%;
        background-color: #24ba58;
        border-color: #24ba58;
      }

      .el-button--success:active {
        background-color: skyblue;
        border-color: skyblue;
      }

      /deep/.el-input__inner:focus {
        border-color: #24ba58;
      }
    }
  }
}
</style>